import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center px-6" data-testid="not-found-page">
      <div className="text-center">
        <h1 className="font-display text-7xl md:text-9xl font-medium mb-4">404</h1>
        <p className="mb-8 text-lg text-muted-foreground">Diese Seite wurde nicht gefunden.</p>
        <Link to="/" className="underline underline-offset-4 hover:text-[hsl(var(--accent-ink))]" data-testid="not-found-home-link">Zur Startseite</Link>
      </div>
    </main>
  );
}
